<template>
  <div class="geo-panel mt-4">
    <div class="geo-summary mb-4">
      {{ $t('seoScore.detail.ai.summary', [report.score, keyword]) }}
    </div>
    <div class="geo-box mb-4">
      <div class="font-weight-medium mb-3">{{ $t('seoScore.detail.ai.platformsTitle') }}</div>
      <div v-for="platform in report.platforms" :key="platform.id" class="geo-bar-row">
        <div class="geo-bar-label">{{ $t('seoScore.detail.ai.platforms.' + platform.id) }}</div>
        <div class="geo-bar-track">
          <div class="geo-bar-fill" :style="{ width: platform.score + '%' }" />
        </div>
        <div class="geo-bar-score">{{ platform.score }}%</div>
      </div>
    </div>
    <div class="geo-box">
      <div class="font-weight-medium mb-3">{{ $t('seoScore.detail.ai.factorsTitle') }}</div>
      <div v-for="factor in report.factors" :key="factor.id" class="geo-factor">
        <v-icon small :color="factor.ok ? 'success' : 'error'" class="mr-2">
          {{ factor.ok ? 'check' : 'close' }}
        </v-icon>
        <div>
          <div class="font-weight-medium">{{ $t('seoScore.detail.ai.factors.' + factor.id + '.title') }}</div>
          <div class="caption text--secondary">
            {{ $t('seoScore.detail.ai.factors.' + factor.id + (factor.ok ? '.ok' : '.fail'), [keyword]) }}
          </div>
        </div>
      </div>
    </div>
    <div class="caption text--secondary mt-3">
      {{ isAnalyze ? $t('seoScore.detail.ai.modeAnalyze') : $t('seoScore.detail.ai.modeWrite') }}
    </div>
  </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import {evaluateAiVisibility, AiVisibilityReport} from "@/service/geoEatScore";

    export default Vue.extend({
        name: "SeoAiVisibilityPanel",
        computed: {
            report(): AiVisibilityReport {
                return evaluateAiVisibility(this.$store.getters.article);
            },
            keyword(): string {
                return this.$store.getters.article.selectedKeyword || this.$store.getters.article.keyword || '';
            },
            isAnalyze(): boolean {
                return !!this.$store.getters.article.isAnalyze;
            }
        }
    });
</script>

<style lang="sass" scoped>
.geo-summary
    background: rgba(110, 170, 52, 0.12)
    border-left: 4px solid var(--v-accent-base)
    border-radius: 10px
    padding: 12px 14px
    line-height: 1.5
    color: inherit

.geo-box
    border: 1px solid #e2e8f0
    border-radius: 12px
    padding: 14px 16px
    background: rgba(255, 255, 255, 0.7)

.geo-bar-row
    display: grid
    grid-template-columns: minmax(120px, 180px) 1fr 48px
    gap: 10px
    align-items: center
    margin-bottom: 10px
    font-size: 13px

.geo-bar-track
    height: 8px
    border-radius: 99px
    background: #e2e8f0
    overflow: hidden

.geo-bar-fill
    height: 100%
    border-radius: 99px
    background: var(--v-warning-base)

.geo-bar-score
    text-align: right
    font-weight: 600

.geo-factor
    display: flex
    align-items: flex-start
    padding: 10px 0
    border-bottom: 1px solid #edf2f7

    &:last-child
        border-bottom: 0
        padding-bottom: 0

.theme--dark
    .geo-summary
        background: rgba(110, 170, 52, 0.22)
        color: inherit

    .geo-box
        background: rgba(15, 23, 42, 0.35)
        border-color: #334155
</style>
